import Header from "./Movies/Header";
import MoviesContainerPage from "./Movies/MoviesContainer";

const Home = () => {
  return (
    <>
      <Header />

      <section>
        <MoviesContainerPage />
      </section>
    </>
  );
};

export default Home;
